import React from "react";
import PropTypes from "prop-types";
import CouponMessage from "components/CouponMessage";
import BtnCuponDisabled from "components/BtnCuponDisabled";
import { parseCouponDate } from "config/utils";


const CouponSliderRoulette= ({
    coupon = {},
    hasCart = true,
    inCart=null,
    linesMsgMaior=null,
    hasSession = true,
    changeExpired = false,
    roulette=null,
    
    
   
}) => {
    const showingRoulette= (event) => {
        roulette && roulette(event);
        //controlTerms invoca a openTermiConditions de CouponSlider
    };


    return (
        <div
            className={
                (coupon.cuponBonus == true && coupon.cuponHabilitado == false
                    ? "coupon-bonus-disable"
                    : "") +
                " coupon " +
                (hasCart && inCart && "active")
            }
        >
            <div className="row">
                <div className="col-7">
                    <div className="container p-0">
                        <div className="row">
                            <div className="col-12 info">
                                <CouponMessage
                                    data={coupon}
                                    inCart={inCart}
                                    linesMsgMaior={linesMsgMaior}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-5">
                    <p className={"image"}>
                        <img src={coupon.image} alt={coupon.nameCoupon} />
                    </p>
                    <div className="buttons">
                        {coupon.cuponBonus == true &&
                        coupon.cuponHabilitado == false ? (
                            <BtnCuponDisabled />
                        ) : (
                            <a href="#" 
                           
                                                onClick={(event) =>
                                                    showingRoulette(
                                                        event
                                                    )
                                                }
                            className={"btn no-hover"}>
                                <span className="add">Ir a Jugar</span>
                            </a>
                        )}
                    </div>
                </div>
                <div className="col-12">
                    <p className="valid">
                        Vence{" "}
                        {parseCouponDate(coupon.vencimiento, changeExpired)}
                    </p>
                    {hasSession && (
                        <>
                            <p className="legal">
                                <a href="#">Ver legal</a>
                            </p>
                            {hasCart != false && (
                                <p className="productos">
                                    <a href="#">productos</a>
                                </p>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
CouponSliderRoulette.propTypes = {
    coupon: PropTypes.object,
    hasCart: PropTypes.bool,
    inCart: PropTypes.bool,
    linesMsgMaior:PropTypes.number,
    hasSession: PropTypes.bool,
    changeExpired: PropTypes.bool,
    roulette:PropTypes.func,
    
};


export default CouponSliderRoulette;
